import { NextPageContext } from 'next';

import { AppCollection as AppStore } from '@/stores/AppStore';

import { isServer } from './env';
import { generateStore } from './generateStore';

interface IContext extends NextPageContext {
  store: AppStore;
}

type GetInitialPropsFn = (ctx: IContext) => any;

/**
 * @deprecated use getServerSideProps
 */
export const gIPDecorator = (gIP: GetInitialPropsFn) => async (ctx: NextPageContext) => {
  const store = generateStore();

  if (ctx.req) {
    store.cookie = ctx.req.headers.cookie;
  }

  const newContext = { store, ...ctx };

  const props = await gIP(newContext);

  return {
    ...props,
    snapshot: isServer ? store.snapshot : null,
  };
};
